import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VoucherInformationService {

  private formDataSubject: Subject<String> = new Subject<String>();
  value$ = this.formDataSubject.asObservable();
  private updateVoucherStatusPartial: Subject<String> = new Subject<String>();
  partialStatus = this.updateVoucherStatusPartial.asObservable();
  private updateVoucherStatusTotal: Subject<String> = new Subject<String>();
  totalStatus = this.updateVoucherStatusTotal.asObservable();
  private updateDeleteVaraint: Subject<boolean> = new Subject<boolean>();
  deleteVaraint = this.updateDeleteVaraint.asObservable();
  private updateVoucherStatusActive: Subject<String> = new Subject<String>();
  activeStatus = this.updateVoucherStatusActive.asObservable();
  private activeVoucher: BehaviorSubject<String> = new BehaviorSubject<String>("");
  activeCheck = this.activeVoucher.asObservable();
  private activeVariant: BehaviorSubject<String> = new BehaviorSubject<String>("");
  activeCheckVariant = this.activeVariant.asObservable();
  private updateExpiryDate: Subject<any> = new Subject<any>();
  dateStatus = this.updateExpiryDate.asObservable(); 
  variantRegistryArray :any[]=[]
  private updateExpiryDateIndex: Subject<any> = new Subject<any>();
  dateStatusIndex = this.updateExpiryDateIndex.asObservable();


  constructor(private readonly http: HttpClient) { 
    
  }



  getVoucherList() {
    return this.http.get<any>('mhvoucher/vouchers/vouchertypes')
  }

  getVoucherPartners() {
    return this.http.get<any>('mhvoucher/vouchers/partners')
  }

  getVoucherTags() {
    return this.http.get<any>('mhvoucher/vouchers/tags')
  }

  getVoucherMerchants() {  
    return this.http.get<any>('mhvoucher/merchants?format=FULL&active=true')
  }

  getMerchantDetails(id:any) {
    return this.http.get<any>('mhvoucher/merchants/'+id+'?include=LOCATION')
  }

  getCategoryDetails() {
    return this.http.get<any>('mhvoucher/vouchers/categories')
  }

  getVoucherValidityDetails() {
    return this.http.get<any>('mhvoucher/vouchers/vouchervalidity')
  }

  createVoucher(data: any) {
    return this.http.post<any>('mhvoucher/vouchers', data)
  }

  deleteVoucher(id: any) {
    return this.http.delete<any>('mhvoucher/vouchers/'+id)
  }

  deleteVoucherVariant(parentId: any,variantId:any) {
    return this.http.delete<any>('mhvoucher/vouchers/'+parentId+'/variants/'+variantId)
  }

  updateFormData(value: string) {
    this.formDataSubject.next(value);
  }

  updateVoucherStatusForPartial(value: string) {
    this.updateVoucherStatusPartial.next(value);
  }

  updateVoucherStatusForTotal(value: string) {
    this.updateVoucherStatusTotal.next(value);
  }

  deleteVoucherVariantStatus(value: boolean){
    this.updateDeleteVaraint.next(value)
  }

  updateVoucherStatusForActive(value: string) {
    this.updateVoucherStatusActive.next(value);
  }

  activeVoucherDetail(value:string) {
    this.activeVoucher.next(value)
  }

  activeVariantDetail(value:string) {
    this.activeVariant.next(value)
  }

  updateExpiryDateStatus(value: string,index:any) {
    this.updateExpiryDate.next(value)
    this.updateExpiryDateIndex.next(index)
    if(!this.variantRegistryArray.includes(index)){
      this.variantRegistryArray.push(index)
    }
  }

  getVariantRegistryArray() {
    return this.variantRegistryArray;
  }

  setVariantRegistryArray() {
    this.variantRegistryArray=[];
  }

  getLayoutData (voucherType: string, externalId: string, marketId: string) {
    return this.http.get<any>(`mhvoucher/vouchers/vouchertypes/${voucherType}/sku/${externalId}/content?marketTagId=${marketId}`)
  }


}